/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { v4 as uuidv4 } from 'uuid';
import {
  Modal,
  Dimmer,
  Segment,
  Loader,
  Label,
  Table,
  Header,
  Image,
  Icon,
} from 'semantic-ui-react';
import cx from 'classnames';
import api from '../../api';
import userPic from '../../images/components/profile/profile_icon_1.png';
import closeBtn from '../../images/common/close-btn.svg';
import searchIcon from '../../images/common/search_icon.png';
import './NestedAssignIssue.css';

class NestedAssignIssue extends Component {
  constructor(props) {
    super(props);
    this.modalBody = null;
    this.state = {
      memberList: [],
      isOpenWarn: false,
      //id: props.id,
      selectedId: '',
      selectedOwner: '',
      targetName: props.targetName,
      uploadedFileId: props.uploadedFileId,
      isLoadingnestedPopup: false,
      //isOpenNestedPopup: props.isOpenNestedPopup,
      //activeNestedPopup: props.activeNestedPopup,
      pageSize: 100,
      searchKeyword: '',
    };

    this.handleSearchMember = this.handleSearchMember.bind(this);
    this.handleProjectMemberChange = this.handleProjectMemberChange.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.handleSelectMember = this.handleSelectMember.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.clearSearch = this.clearSearch.bind(this);
    this.closeNestedPopup = this.closeNestedPopup.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount() {
    if (this.nestedPopup) {
      this.searchDetailIssueOwner();
    }
  }

  handleSelectMember(memberId, profile, email) {
    if (memberId === this.state.selectedId) {
      this.setState({
        selectedId: '',
        selectedOwner: '',
      });
    } else {
      this.setState({
        selectedId: memberId,
        selectedOwner: profile === '' ? email : profile,
      });
    }
  }

  handleProjectMemberChange(e) {
    this.setState({
      searchKeyword: e.target.value,
      //searchKeywordError: '',
    });
  }

  handleSearchMember(event) {
    if (event.key === 'Enter') {
      if (event.target.value === '' || event.target.value.length < 2) {
        this.setState(
          {
            errSearch: true,
            isFocus: false,
          },
          () => {
            setTimeout(() => {
              this.setState({
                errSearch: false,
                isFocus: true,
              });
            }, 1500);
          }
        );
        return false;
      }
      this.setState(
        {
          memberList: [],
        },
        () => {
          this.searchDetailIssueOwner();
          setTimeout(() => {
            this.setState({
              isFocus: false,
            });
          }, 1500);
        }
      );
    }
  }

  handleFocus() {
    this.setState({
      isFocus: true,
    });
  }

  handleBlur() {
    this.setState({
      isFocus: false,
    });
  }

  onSubmit() {
    const { selectedId, selectedOwner } = this.state;
    const { translate } = this.props;
    if (selectedId === '') {
      this.modalBody = translate('modal.message.select_a_user');
      this.setState({
        isOpenWarn: true,
      });
      return false;
    }
    const obj = {
      selectedId,
      owner: selectedOwner,
      id: this.props.id,
    };
    this.props.changesIssueOwner(obj);
  }

  getProfileImg(value) {
    const profileImg = `/1/users/me/profile_image/${value}`;

    let baseUrl = '//'.concat(location.hostname);
    let profileImgUrl = '';

    if (process.env.NODE_ENV === 'development') {
      baseUrl = baseUrl.concat(':3000');
    } else {
      baseUrl = location.port !== '' ? baseUrl.concat(':', location.port) : '';
    }

    profileImgUrl = profileImg !== '' ? baseUrl.concat(profileImg) : userPic;

    return profileImgUrl;
  }

  searchDetailIssueOwner(pageNo, perPage) {
    const { uploadedFileId, searchKeyword } = this.state;
    const page = pageNo || 1;
    const limit = perPage || this.state.pageSize;

    const obj = {
      search: searchKeyword,
      page,
      limit,
    };

    this.setState({
      isLoadingnestedPopup: true,
    }, () => {
      api
        .searchDetailIssueOwner(obj, uploadedFileId)
        .then((response) => {
          const data = response.response;
          this.setState({
            isLoadingnestedPopup: false,
            memberList: data,
          });
        })
        .catch((err) => {
          console.log(err);
          this.setState({
            isLoadingnestedPopup: false,
          });
        });
    });
  }

  clearSearch() {
    this.setState(
      {
        searchKeyword: '',
        memberList: [],
      },
      () => {
        this.searchDetailIssueOwner();
      }
    );
  }

  closeNestedPopup() {
    this.setState({
      memberList: [],
      searchKeyword: '',
      selectedId: '',
      selectedOwner: '',
    });
    this.props.closeNestedPopup();
  }

  closeModal() {
    this.setState({
      isOpenWarn: false,
    });
  }

  convertToString(string) {
    if (string === 'clarityadmin@insignary.com') {
      return 'Admin';
    } if (string === 'licensemanager@insignary.com') {
      return 'Licensemanager';
    }
    return string;
  }

  render() {
    const {
      memberList,
      //isOpenNestedPopup,
      //activeNestedPopup,
      isLoadingnestedPopup,
      searchKeyword,
      errSearch,
      isFocus,
      //id,
      selectedId,
    } = this.state;
    const { translate } = this.props;

    return (
      <div
        className="nested_popup_wrap show"
        ref={(element) => {
          this.nestedPopup = element;
        }}
      >
        <div style={{ position: 'relative', overflow: 'hidden', height: '100%' }}>
          <div className="nested_popup_header">
            <h2 className="nested_popup_name">
              {translate('modal.title.assigning_issue')}
              <em style={{ fontSize: '11px', fontWeight: 'normal', color: '#777777' }}>
                (
                <Icon name="info circle" />
                {this.state.targetName}
                )
              </em>
            </h2>
            <a
              className="popup_close_button"
              onClick={this.closeNestedPopup}
              onKeyUp={this.closeNestedPopup}
            >
              <img src={closeBtn} alt="" />
            </a>
          </div>
          <div className="nested_popup_contents">
            <div className="nested_popup_content_wrap">
              <div className="nested_popup_content">
                <div className="search_box">
                  <span className="search_icon">
                    <img src={searchIcon} alt="" />
                  </span>
                  <input
                    type="text"
                    value={searchKeyword}
                    placeholder={translate('modal.title.placeholder_name_email')}
                    onChange={this.handleProjectMemberChange}
                    onKeyPress={this.handleSearchMember}
                    onFocus={this.handleFocus}
                    onBlur={this.handleBlur}
                  />
                  <a className="reset_icon" onClick={this.clearSearch} onKeyUp={this.clearSearch}>
                    x
                  </a>
                  {errSearch && (
                    <Label basic color="red" pointing>
                      {translate('contents_header.message.least_two_required_to_search')}
                    </Label>
                  )}
                  {isFocus && <Label pointing>{translate('modal.title.label_name_email')}</Label>}
                </div>
              </div>
              <div className="nested_popup_content">
                <div className="table_wrap">
                  <Scrollbars
                    style={{
                      height: '188px',
                      overflow: 'hidden',
                      position: 'relative',
                    }}
                  >
                    {
                      isLoadingnestedPopup ? (
                        <Segment>
                          <Dimmer active inverted>
                            <Loader inverted size="small" />
                          </Dimmer>
                        </Segment>
                      ) : (
                        <Table
                          selectable
                          celled
                        >
                          <Table.Header>
                            <Table.Row>
                              <Table.HeaderCell>{translate('modal.title.name')}</Table.HeaderCell>
                              <Table.HeaderCell>{translate('modal.title.email')}</Table.HeaderCell>
                              <Table.HeaderCell>{translate('modal.title.issues')}</Table.HeaderCell>
                            </Table.Row>
                          </Table.Header>
                          <Table.Body>
                            {
                              memberList.map((item) => {
                                return (
                                  <Table.Row
                                    key={uuidv4()}
                                    onClick={() => {
                                      this.handleSelectMember(item.id, item.profile, this.convertToString(item.email));
                                    }}
                                    className={cx('assign_issue', {
                                      selected: selectedId === item.id,
                                    })}
                                  >
                                    <Table.Cell>
                                      <Header as="h4" image>
                                        <Image src={this.getProfileImg(item.id)} rounded size="mini" />
                                        <Header.Content
                                          style={{ fontSize: '11px', color: '#474747' }}
                                        >
                                          {item.profile}
                                        </Header.Content>
                                      </Header>
                                    </Table.Cell>
                                    <Table.Cell>{this.convertToString(item.email)}</Table.Cell>
                                    <Table.Cell>{item.issues}</Table.Cell>
                                  </Table.Row>
                                );
                              })
                            }
                          </Table.Body>
                        </Table>
                      )
                    }
                  </Scrollbars>
                </div>
              </div>
            </div>
            <div className="nested_popup_button_wrap">
              <a
                className="button cencel_button"
                style={{ cursor: 'pointer' }}
                onClick={this.closeNestedPopup}
                onKeyUp={this.closeNestedPopup}
              >
                {translate('modal.button.cancel')}
              </a>
              <a
                className="button save_button"
                onClick={this.onSubmit}
                onKeyUp={this.onSubmit}
              >
                {translate('modal.button.save')}
              </a>
            </div>
          </div>
        </div>
        <Modal open={this.state.isOpenWarn} onClose={this.closeModal}>
          <div className="modal_popup_wrap">
            <div className="modal_popup_box">
              <div className="modal_popup">
                <h2 className="title">{translate('modal.title.attention')}</h2>
                <p className="text">{this.modalBody}</p>
                <div className="button_wrap">
                  <a
                    className="center_button"
                    style={{ cursor: 'pointer' }}
                    onClick={this.closeModal}
                    onKeyUp={this.closeModal}
                  >
                    {translate('modal.button.ok')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

export default NestedAssignIssue;
